import { useState, useCallback, useContext } from "react";
import { formatDate, basePath } from "../Constants/constant";
import axios from "axios";
import { AppContext } from '../ContextApi/ContextApi';
import BasicButton from "../Usables/Buttons";
import InputField from "../Usables/InputField";
import Dropdown from "../Usables/Dropdown";
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const RecruiterPositionWiseReport = ({allUsers, usersOption, setUsersOption}) => {
    const { apiHeaderJSON } = useContext(AppContext);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [filterData, setFilterData] = useState({fromDate: "", toDate: "",
        recruiterId: "", company: "", position: "",});

    const handleExport = async () => {
        try {
            setLoadingFilter('1');
            Swal.fire({
                title: 'Please wait...',
                html: 'Your file is being prepared for download.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
                const response = await axios.get(`${basePath}/Reports/RecruiterPositionWiseReport`, {
                    params: {
                        filter: filterData,
                    },
                    headers: apiHeaderJSON,
                    responseType: 'blob'  
                });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${allUsers.find(val => val.value === filterData?.recruiterId)?.label}'s Report from ${formatDate(filterData?.fromDate)} to ${formatDate(filterData?.toDate)}.xlsx`);
            document.body.appendChild(link);
            link.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            Swal.close();
            toast.success("Excel Exported Successfully!");
            setLoadingFilter(false);
        } catch (error) {
            let errorMsg = "There was a problem with the download";
            if (error.response && error.response.data) {
                const blob = error.response.data;
                try {
                    // Read the blob as text (usually contains JSON string)
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const json = JSON.parse(reader.result);
                            errorMsg = json?.error || json?.message || errorMsg;
                        } catch (e) {
                            console.warn("Could not parse error response:", e);
                            errorMsg = "Something went wrong while processing the error.";
                        }
                        toast.error(errorMsg);
                        Swal.close();
                        setLoadingFilter(false);
                    };
                    reader.readAsText(blob);
                } catch (e) {
                    toast.error("Unable to read error response.");
                    Swal.close();
                    setLoadingFilter(false);
                }

            } else {
                // Network error or no response
                toast.error(error.message || errorMsg);
                Swal.close();
                setLoadingFilter(false);
            }
            Swal.close();
            
        }
    };

    const handleCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        // console.log(checked);
        const num = !checked ? 2 : 1;
        // console.log("allUsers",allUsers);
        const all = allUsers?.filter((val)=>{
            // console.log("val?.activated === e.target.value",idx + 1,"=>",val?.activated, num,val?.activated === num)
            if(val?.activated === num) return val;
        });
        setFilterData({ ...filterData, isActive: checked }); 
        // console.log("all",all);
        setUsersOption(all);
    },[allUsers, filterData]);
    
    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterData({ ...filterData, [name]: value, });   
    },[filterData]);
    
    const handleClear = useCallback(()=> {
        // setLoadingFilter("2");
        setFilterData({
            fromDate: "",
            toDate: "",
            recruiterId:""    
        });
        
    }, []);

    return (
        <div className='grayBlurShadow bg-white p-6 mt-6 rounded-2xl'>
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900">📊 Recruiter's Position-Wise Reports</h1>
                <p className="text-sm text-gray-500 mt-1">Filter by date range and recruiter to generate detailed reports.</p>
            </div>
            <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 mt-3'>
                <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                    disabled={loadingFilter === '1'}
                    value={filterData?.fromDate}
                    onChange={handleChangeFilter}
                />
                <InputField  id="toDate" name="toDate" type="date" label="To:"
                    disabled={loadingFilter === '1'}
                    value={filterData?.toDate}
                    onChange={handleChangeFilter}
                />
                <Dropdown id="recruiterId" name="recruiterId" label="Recruiter:"
                    onChange={handleChangeFilter}
                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                    placeholder={`Select Recruiter`}
                    value={filterData?.recruiterId}
                    options={usersOption}
                    search={true} // to enable search input
                    checkBox={true} // to enable checkbox
                    checkValue={filterData?.isActive} // to make checkbox check and uncheck
                    onCheck={handleCheck} // to make changes in list of options onChange  
                />
                    <div className="flex gap-3 col-span-1">
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Export Report</label>
                        <BasicButton onClick={() => handleExport()}  buttonName='Export Report' className='darkPurple text-nowrap' shadow={true}
                        disabled={ loadingFilter || (!filterData?.fromDate || !filterData?.toDate || !filterData?.recruiterId)}
                        loading={loadingFilter === "1"} 
                        loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                        <BasicButton  onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                        disabled={ loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.recruiterId)}
                        loading={loadingFilter === "2"}
                            loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                    </div>
                    
                </div>
                    
            </div>
        </div>  
    )
}

export default RecruiterPositionWiseReport;